
import { Table, TableBody, Modal, TableCell, TableContainer, TableHead, TableRow, AppBar, Box, Toolbar, TextField, useTheme, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Divider, CssBaseline } from "@mui/material";
import React, { useState } from "react";
import { tokens } from "../../../theme/theme";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Close from '@mui/icons-material/Close';
import Searchicon from '@mui/icons-material/Search';


import CustomTableContainer from "../../../Layout/CustomTableContainer";
import GetBillOfMaterial from "../bom/GetBOM";
import useBillOfMaterialListSummary from "../../../hooks/useBillOfMaterialListSummary";

const BillOfMaterialSummary = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('Bill Of Material');
    const [selectedMenuFirst, setSelectedMenuFirst] = useState('Bulk Update');
    const [selectedStatus, setSelectedStatus] = useState('All');
    const openFirst = Boolean(anchorElFirst);
    const [newVendor, setNewVendor] = useState(false);
    const [vendorHome, setVendorHome] = useState(true);
    const [getBillOfMaterial, setGetBillOfMaterial] = useState(false);

    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);


    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);   
    const openSecond = Boolean(anchorElSecond);

    const [anchorElMenu, setAnchorElMenu] = useState(null);
    const openMenu = Boolean(anchorElMenu);


    const { materialList, setMaterialList, selectMaterial, selectMaterialID, loadMaterialListByID, } = useBillOfMaterialListSummary();    

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Material') {
            setSelectedStatus('All');
        }
        else if (option === 'Active Material') {
            setSelectedStatus('Active');
        }
        else if (option === 'In Active Material') {
            setSelectedStatus('InActive');
        }

        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {      
        handleMenuCloseSecond();
    };

    const [editMaterialID, setEditMaterialID] = useState(0);

    const handleShowNewVendor = () => {
        setEditMaterialID(0);
        setVendorHome(false);
        setNewVendor(true);
        setGetBillOfMaterial(false);
    }

    const handleGetBillOfMaterial = () => {
        setEditMaterialID(0);
        setVendorHome(false);
        setNewVendor(false);
        setGetBillOfMaterial(true);
    }


    const handleCallEdit = (value, poID, poNumber) => {
        setEditMaterialID(value);
        setVendorHome(false);       
        setGetBillOfMaterial(true);
    };

    const handlecallback = () => {
        setVendorHome(true);
        setNewVendor(false);
        setGetBillOfMaterial(false);
        loadMaterialListByID();
    }

    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        material_code: '',
        material_name: '',
        status: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = materialList.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        } else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    const filteredData = materialList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    return (
        <Box m={"2px"}>
            <CssBaseline />
            {vendorHome && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        {showFirstToolbar && (
                            <>
                                <Button color="secondary" onClick={handleMenuClickFirst} endIcon={<ExpandMoreIcon sx={{ color: "teal" }} />} sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }} >  {selectedOptionFirst} </Button>

                                <Menu anchorEl={anchorElFirst} open={openFirst} onClose={handleMenuCloseFirst} >
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Bill Of Material')}>All </MenuItem>
                                </Menu>

                                {/* Adding margin-left: auto to push the button to the right */}
                                <Button size="small" variant="contained" onClick={handleGetBillOfMaterial} color="secondary" startIcon={<AddIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Get BOM </Button>
                               
                                {/* Second Menu */}
                                <IconButton size="small" color="secondary" aria-label="menu" sx={{ ml: 2 }} onClick={handleMenuClickSecond}>
                                    <MoreVertIcon />
                                </IconButton>

                                <Menu anchorEl={anchorElSecond} open={openSecond} onClose={handleMenuCloseSecond} >

                                    <MenuItem onClick={() => handleMenuItemClickSecond('Import Materials')}>
                                        <ListItemIcon>
                                            <ImportExportIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Import Materials" />
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Export Materials')}>
                                        <ListItemIcon>
                                            <FileDownloadIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Export Materials" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                        <ListItemIcon>
                                            <ListAltIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Preference " />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                        <ListItemIcon>
                                            <RefreshIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Refresh List" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                        <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                            Reset Columns Width
                                        </Button>
                                    </MenuItem>
                                </Menu>

                                <IconButton size="small" aria-label="menu" sx={{ mr: 1, ml: 1 }} onClick={handleMenuClickSecond}  >
                                    <HelpIcon />
                                </IconButton>

                                <div>
                                    <IconButton onClick={handleBackWinderMachineEntry} >
                                        <Close fontSize="inherit" style={{ color: "#2196F3" }} />
                                    </IconButton>
                                </div>
                            </>
                        )}
                    </Toolbar>
                </AppBar>
            )}

            {vendorHome && (
                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    <TableCell>BILL OF MATERIAL CODE</TableCell>
                                    <TableCell>MO NUMBER</TableCell>                                   
                                    <TableCell>PRODUCT</TableCell>
                                    <TableCell>CREATED BY</TableCell>
                                    <TableCell>CREATED DATE</TableCell>
                                    <TableCell>STATUS</TableCell>
                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>

                                                <TextField
                                                    label="Material Code"
                                                    name="material_code"
                                                    value={filters.material_code}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Material Name"
                                                    name="material_name"
                                                    value={filters.material_name}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Status"
                                                    name="status"
                                                    value={filters.status}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row) => (
                                    <TableRow key={row.id_bom}>
                                        <TableCell>
                                            <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleCallEdit(row.id_bom)}
                                            >
                                                {row.bom_code}
                                            </span>
                                        </TableCell>
                                        <TableCell>{row.mo_number}</TableCell>
                                        <TableCell>{row.varietycode}</TableCell>
                                        <TableCell>{row.createdby}</TableCell>
                                        <TableCell>{row.bom_date}</TableCell>
                                        <TableCell>{row.status}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>
            )}      

            {getBillOfMaterial && (
                <>
                    <GetBillOfMaterial handlecallback={handlecallback} editMaterialID={editMaterialID} setEditMaterialID={setEditMaterialID} />
                </>
            )}

        </Box>
    );
}

export default BillOfMaterialSummary;





